var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAllSuggested4(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.5651 17.2666C54.931 11.3394 50.1637 6.57211 44.2394 5.91177C39.8389 5.42127 35.3208 5 30.7143 5C26.1078 5 21.5897 5.42127 17.1892 5.91177C11.2649 6.57211 6.4976 11.3394 5.86343 17.2666C5.39531 21.6422 5 26.1345 5 30.7143C5 35.2941 5.39531 39.7863 5.86343 44.1619C6.4976 50.0892 11.2649 54.8565 17.1892 55.5168C21.5897 56.0073 26.1078 56.4286 30.7143 56.4286C35.3208 56.4286 39.8389 56.0073 44.2394 55.5168C50.1637 54.8565 54.931 50.0892 55.5651 44.1619C56.0333 39.7863 56.4286 35.2941 56.4286 30.7143C56.4286 26.1345 56.0333 21.6422 55.5651 17.2666Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55.5651 17.2666C54.931 11.3394 50.1637 6.57211 44.2394 5.91177C39.8389 5.42127 35.3208 5 30.7143 5C26.1078 5 21.5897 5.42127 17.1892 5.91177C11.2649 6.57211 6.4976 11.3394 5.86343 17.2666C5.39531 21.6422 5 26.1345 5 30.7143C5 35.2941 5.39531 39.7863 5.86343 44.1619C6.4976 50.0892 11.2649 54.8565 17.1892 55.5168C21.5897 56.0073 26.1078 56.4286 30.7143 56.4286C35.3208 56.4286 39.8389 56.0073 44.2394 55.5168C50.1637 54.8565 54.931 50.0892 55.5651 44.1619C56.0333 39.7863 56.4286 35.2941 56.4286 30.7143C56.4286 26.1345 56.0333 21.6422 55.5651 17.2666Z",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2221 73.0403C29.2218 71.7454 26.7982 69.3334 25.4937 66.3408",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M55.078 74.7188C53.19 74.8399 51.2846 74.913 49.3638 74.913C47.4429 74.913 45.5374 74.8399 43.6494 74.7188",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M73.2348 66.3408C71.9303 69.3334 69.5068 71.7454 66.5068 73.0403",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M74.8936 43.4834C75.009 45.3713 75.0787 47.2768 75.0787 49.1977C75.0787 51.1186 75.009 53.0241 74.8936 54.912",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5068 25.3555C69.5068 26.6504 71.9303 29.0625 73.2348 32.0547",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllSuggested4);
export default __webpack_public_path__ + "static/media/allSuggested4.d2a8b325a5bcf0ccd50c2ec984ad424f.svg";
export { ForwardRef as ReactComponent };